<template>
  <div />
</template>

<script>
export default {
  name:     "TariffsArchiveIndex",
  computed: {},
  mounted() {
    const types = this.$store.getters['appUser/selectedHouse'].available_types;
    const firstType = types ? types.split(',')[0] : null;

    if (firstType) {
      this.$router.replace({
        name:   'uc_b_tariffs_archive',
        params: {
          apartmentsType: firstType,
        },
      });
    }
  },
};
</script>

<style scoped>

</style>
